// Quản lý state + tải dữ liệu cho trang Quản lý Bình luận
import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import postApi from "../../../../api/postApi";

const PAGE_SIZE = 30;

export default function useComments() {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [unansweredTotal, setUnansweredTotal] = useState(0);
    const [pendingTotal, setPendingTotal] = useState(0);

    // Bộ lọc
    const [page, setPage] = useState(1);
    const [q, setQ] = useState("");
    const [postId, setPostId] = useState("");
    const [unanswered, setUnanswered] = useState(false);
    const [status, setStatus] = useState(""); // "" = tất cả | "pending" | "approved"
    const [dateRange, setDateRange] = useState(null); // [dayjs, dayjs] | null

    const fetchComments = useCallback(async () => {
        try {
            setLoading(true);
            const qs = new URLSearchParams({ page: String(page), limit: String(PAGE_SIZE) });
            if (q.trim()) qs.set("q", q.trim());
            if (postId.trim()) qs.set("postId", postId.trim());
            if (unanswered) qs.set("unanswered", "1");
            if (status) qs.set("status", status);
            if (dateRange?.[0]) qs.set("from", String(dateRange[0].startOf("day").valueOf()));
            if (dateRange?.[1]) qs.set("to", String(dateRange[1].endOf("day").valueOf()));
            const { data } = await postApi.getAllComments(qs.toString());
            setComments(data.comments || []);
            setTotal(data.total || 0);
            setUnansweredTotal(data.unansweredTotal || 0);
            setPendingTotal(data.pendingTotal || 0);
        } catch {
            message.error("Không thể tải danh sách bình luận");
        } finally {
            setLoading(false);
        }
    }, [page, q, postId, unanswered, status, dateRange]);

    useEffect(() => {
        fetchComments();
    }, [fetchComments]);

    // Đổi bộ lọc => luôn quay về trang 1
    const resetToFirst = (setter) => (value) => {
        setPage(1);
        setter(value);
    };

    return {
        comments,
        loading,
        total,
        unansweredTotal,
        pendingTotal,
        pageSize: PAGE_SIZE,
        page,
        setPage,
        q,
        setQ: resetToFirst(setQ),
        postId,
        setPostId: resetToFirst(setPostId),
        unanswered,
        setUnanswered: resetToFirst(setUnanswered),
        status,
        setStatus: resetToFirst(setStatus),
        dateRange,
        setDateRange: resetToFirst(setDateRange),
        refetch: fetchComments,
    };
}
